import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import './MRTable.scss';

const MRTable = ({ loading, data, columns }) => {
  const navigate = useNavigate();

  const theme = createTheme({
    palette: {
      primary: {
        main: '#3C5A7B',
      },
    },
    typography: {
      fontFamily: 'Inter, sans-serif',
    },
    components: {
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: '#3C5A7B',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: '#3C5A7B',
          },
        },
      },
    },
  });

  const memoColumns = useMemo(() => columns, [columns]);
  const memoData = useMemo(() => data, [data]);

  const table = useMaterialReactTable({
    columns: memoColumns,
    data: memoData,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnResizing: true,
    enableColumnFilters: true,
    enableFacetedValues: true,
    getRowId: (originalRow) => originalRow.id,
    state: { isLoading: loading },
    positionToolbarAlertBanner: 'none',
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: false,
      showFirstButton: true,
      showLastButton: true,
    },
    paginationDisplayMode: 'pages',
    initialState: {
      columnOrder: [
        'importance',
        'status',
        'poll_label',
        'riding',
        'type',
        'name',
        'description',
        'created_by_ai',
        'staffer_fullname',
        'date_utc',
      ],
      pagination: { pageSize: 10, pageIndex: 0 },
      showColumnFilters: true,
    },
    muiTableBodyCellProps: {
      sx: {
        marginRight: '12px',
        color: '#343434',
        fontSize: '14px',
        fontWeight: 'normal',
        border: 'none',
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        marginRight: '12px',
        color: '#343434',
        fontSize: '16px',
        fontWeight: 500,
        border: 'none',
      },
    },
    muiTableHeadRowProps: {
      sx: {
        borderTop: '1px solid #D3D3D3',
        borderBottom: '1px solid #D3D3D3',
      },
    },
    muiTableBodyRowProps: ({ row }) => {
      return {
        onClick: () => {
          navigate(`/message/${row.id}`);
        },
        sx: {
          cursor: 'pointer',
          borderBottom: '1px solid #D3D3D3',
          transition: 'background-color 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: '#F7F7F7 !important',
          },
        },
      };
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="mr-table">
        <MaterialReactTable table={table} />
      </div>
    </ThemeProvider>
  );
};

export default MRTable;
